import React from 'react';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import PageHeader from '../../../PageHeader.js';
import BreadCrumbs from '../../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../../icons/ProjectBreadcrumbIcon.jsx';
import {
  ProjectLink,
  ProjectsLink,
  ProjectStakeholdersLink,
  StakeholderProfileLink,
} from '../../../../links/index.jsx';

const StakeholderFormHeader = ({
  project,
  stakeholder,
  stakeholderId,
  editing,
}) => {
  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ProjectStakeholdersLink projectId={project.id}>
          Stakeholder Analysis
        </ProjectStakeholdersLink>

        {editing ? (
          <StakeholderProfileLink
            projectId={project.id}
            stakeholderId={stakeholderId}
          >
            {stakeholder.name}
          </StakeholderProfileLink>
        ) : null}
        <span>{editing ? 'Edit' : 'Add'} Stakeholder Profile</span>
      </BreadCrumbs>
    </PageHeader>
  );
};
export default StakeholderFormHeader;
